import moment from 'moment'
import * as React from 'react'

import { Select } from 'main/ui'
import { formatTime, normalizeTime, optionsRange, TIME_FORMAT } from 'main/util/time'

interface IProps {
  min: string | null
  max: string | null
  label?: string
  placeholder?: string
  validationHint?: string
  roundedCorners?: boolean
  value: string | null
  disabled: boolean
  invalid: boolean
  onChange: (value: string | null) => void
}

function TimeSelect(props: IProps) {
  const {
    roundedCorners,
    label,
    placeholder,
    validationHint,
    value,
    disabled,
    invalid,
    min,
    max,
    onChange,
  } = props

  return (
    <Select
      value={value && value !== '23:59:00' ? normalizeTime(timeToNearest(value, 15)) : value}
      disabled={disabled}
      invalid={invalid}
      label={label}
      roundedCorners={roundedCorners}
      validationHint={validationHint}
      onChange={newValue => onChange(newValue || null)}
    >
      {!value && <option value="">{placeholder}</option>}
      {optionsRange({ min, max, interval: 15, inclusive: false }).map(time => (
        <option key={time} value={time}>
          {formatTime(time)}
        </option>
      ))}
    </Select>
  )
}

TimeSelect.defaultProps = {
  disabled: false,
  invalid: false,
  max: null,
  min: null,
}

function timeToNearest(time: string, roundTo: number): string {
  const momentTime = moment(time, TIME_FORMAT)
  const hour = momentTime.hour()
  const minute = momentTime.minute()

  if (hour === 23 && minute >= 60 - roundTo / 2) return '23:59:00'

  const roundedMinutes = Math.round(minute / roundTo) * roundTo
  return momentTime.minute(roundedMinutes).second(0).format(TIME_FORMAT)
}

export default React.memo(TimeSelect)
